/**
 * MitEvida API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TimeResolution = 'Hour' | 'Weekdays' | 'Days' | 'Month' | 'Years';

export const TimeResolution = {
    Hour: 'Hour' as TimeResolution,
    Weekdays: 'Weekdays' as TimeResolution,
    Days: 'Days' as TimeResolution,
    Month: 'Month' as TimeResolution,
    Years: 'Years' as TimeResolution
};

